import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { HttpClientService } from 'src/app/service/http-client.service';
import { CommonConstants } from 'src/app/const/const';
import { Utils } from 'src/app/const/func-util';
import { TodaySekoGetRequest } from 'src/app/interfaces/seko';
import { SessionService } from 'src/app/service/session.service';
import { SekoPublishForGet } from 'src/app/interfaces/base';

@Component({
  selector: 'app-cus-huho-today',
  templateUrl: './huho-today.component.html',
  styleUrls: ['./huho-today.component.scss']
})
export class HuhoTodayComponent implements OnInit {

  Const = CommonConstants;
  utils = Utils;
  company_code = null;
  company_info = null;
  seko_data = null;
  seko_data_next = null;
  seko_data_past = null;
  wareki_list = [];
  CONST_NOTFUOND = '現在、掲載されている訃報情報がございません。';
  CONST_NOTALLOWED = '訃報情報の掲載が許可されておりません。';
  err_msg = null;
  is_loading = false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private httpClientService: HttpClientService,
    private router: Router,
    private location: Location,
    private sessionSvc: SessionService,
  ) { }

  async ngOnInit() {
    this.sessionSvc.save('is_today_page', true);
    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      this.company_code = params.get('company_code');
      if (!this.company_code) {
        return;
      }

    });
    this.getWarekiList();
    await this.getSekoList();
  }

  getWarekiList() {
    this.httpClientService.getWarekiList().then((response) => {
      Utils.log(response);
      this.wareki_list = response;
      for (const wareki of this.wareki_list) {
        wareki.begin_date = new Date(wareki.begin_date);
        wareki.end_date = new Date(wareki.end_date);
      }
    }).catch(() => {
      this.wareki_list = [];
    });
  }

  getScheduleForDisplay(seko: any): any {
    if (!seko || !seko.schedules || !seko.schedules.length) {
      return null;
    }
    const matched = seko.schedules.find(s => s.schedule === 2);
    return matched;
  }

  isExpierd(seko: any, service_id: any) {
    if (!seko || !seko.services || !seko.services.length) {
      return true;
    }
    if (!service_id) {
      return true;
    }
    const matched = seko.services.find(s => s.hall_service === service_id);
    if (!matched) {
      return true;
    }
    return matched.is_expired;
  }

  async getSekoList() {
    this.is_loading = true;
    const req = new TodaySekoGetRequest();
    await this.httpClientService.getTodaySekoList(this.company_code, req).then((response) => {
      Utils.log(response);
      if (!response || !response.company) {
        this.err_msg = this.CONST_NOTALLOWED;
        this.is_loading = false;
        return false;
      }
      this.company_info = response.company;
      this.sessionSvc.clear('company_info');
      this.sessionSvc.save('company_info', response.company);
      if (!response.seko_list || !response.seko_list.length) {
        this.err_msg = this.CONST_NOTFUOND;
        this.is_loading = false;
        return false;
      }

      this.seko_data = response.seko_list;

      this.seko_data_next = this.seko_data.filter(v => !v.is_past);
      this.seko_data_past = this.seko_data.filter(v => v.is_past);
      this.is_loading = false;

    }).catch(error => {
      this.err_msg = this.CONST_NOTALLOWED;
      this.is_loading = false;
      return false;
    });
    return true;
  }


  /** 供花ページへのパス（base href を含む。中クリック等のフォールバック用） */
  fuhoPath(seko: { seko_company: string | number; id: string | number }): string {
    const tree = this.router.createUrlTree(['/kumotsu/entry']);
    return this.location.prepareExternalUrl(this.router.serializeUrl(tree));
  }

  /**
   * 新しいタブで開く前に about:blank の子ウィンドウへ現在タブの sessionStorage を複製する。
   * 同一オリジンの子は opener 経由で sessionStorage にアクセスできるため、SPA のセッションを引き継げる。
   */
  openFuho(seko: any, event: MouseEvent): boolean {
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
      return true;
    }
    event.preventDefault();

    const path = this.fuhoPath(seko);
    const url = new URL(path, window.location.origin).href;
    const child = window.open('about:blank', '_blank');
    if (!child) {
      this.router.navigate(['/fuho', `${seko.seko_company}-${seko.id}`]);
      return false;
    }
    this.httpClientService.getSekoFuhoByid(seko.id).then((sekoResponse) => {
      Utils.log(sekoResponse);

      Utils.formatSekoDate(sekoResponse);
      child.sessionStorage.setItem('custom_seko_info', JSON.stringify(sekoResponse));
      child.location.href = url;
      window.open(url, '_blank');

    }).catch(error => {
      return false;
    });
    return true;
  }

}
